import { CircularProgress, CssBaseline, FormControl, FormHelperText, Grid, TextField, Tooltip } from '@mui/material';
import React, { useState } from 'react';
import { Controller } from 'react-hook-form';
import { Autocomplete } from '@mui/lab';
import { CommonService } from '../../../../services';
import PropTypes from 'prop-types';
import _ from "lodash/fp";
import useStyles from '../../CommonStyle/CommonStyle'
import { FormattedMessage } from 'react-intl';


const GroupDescriptionCombo = (props) => {

    const classes = useStyles();
    const { comboProperty, control, errors, comboValue, setComboValue,bpType } = props;
    const [groupDescriptionList, setgroupDescriptionList] = useState([]);
    const [isLoading, setLoading] = useState(false);
    const groupDescriptionData = groupDescriptionList.map((bpGroupMaster) => {
        return { groupDescription: bpGroupMaster.groupDescription }
    });

    const loadGroupDescriptionData = (searchedGroupDescription) => {
        setLoading(true);
        CommonService.GetListApi('/bpGroupMaster', {
            body: {
                bpType: bpType,
                organization: {
                    erpOrgCode: ''
                },
                groupDescription: searchedGroupDescription,
                active: true,
                recordActiveStatus: 'All',
            },
            pageNo: 0,
            sortDir: 'asc',
            sortKey: 'groupDescription',
            recordsPerPage: 100
        })
            .then((response) => {
                setLoading(false);
                setgroupDescriptionList(response.data.content);
            })
    }


    return (
        <React.Fragment>
            <CssBaseline />
            { comboProperty.isHookFormType && (<Grid item xs={12} sm={12} md={12} lg={12}>
                <FormControl fullWidth>
                    <Controller

                        render={({
                            field: { onChange } }) => (
                            <Autocomplete

                                onChange={(event, newValue) => {
                                    onChange(newValue)

                                    if (typeof newValue === 'string') {

                                        if (newValue != null) {
                                            setComboValue({
                                                newValue,
                                            });
                                        }
                                    } else if (newValue && newValue.inputValue) {
                                        // Create a new value from the user input
                                        setComboValue({
                                            title: newValue.inputValue,
                                        });

                                    }
                                    else if (newValue !== null) {

                                        setComboValue(newValue);
                                    } else if (newValue === null) {
                                        setComboValue('')
                                    } else {
                                        setComboValue(newValue);
                                    }
                                }}
                                selectOnFocus
                                handleHomeEndKeys
                                value={comboValue.groupDescription || null}
                                autoHighlight
                                onOpen={() => {
                                    loadGroupDescriptionData('');
                                }}
                                options={groupDescriptionData}
                                getOptionLabel={(option) => {

                                    if (typeof option === 'string') {
                                        return option;
                                    }
                                    if (option.inputValue) {
                                        return option.inputValue;
                                    }
                                    return option.groupDescription;
                                }}
                                getoptionselected={(option, value) => option.groupDescription === value}
                                disabled={comboProperty.isDisabled}
                                renderInput={params => (
                                    <TextField
                                        {...params}
                                        autoFocus={comboProperty.isAutofocus}
                                        name={comboProperty.groupDescription}
                                        size='small'
                                        label={comboProperty.label + (comboProperty.isRequired ? ' *' : '')}
                                        variant={comboProperty.variant}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                )}

                            />
                        )}

                        name={comboProperty.groupDescription}
                        rules={{ required: comboProperty.isRequired }}
                        control={control}
                        defaultValue={{groupDescription: ''}}
                    />
                    {comboProperty.isDisabled && (<FormHelperText>{comboProperty.label} <FormattedMessage id="textfield.error.cannotbeeditedmessage" defaultMessage="can't be edited" /></FormHelperText>)}
                    <div className={classes.error}>
                        {_.get(`${comboProperty.groupDescription}.type`, errors) === "required" && (
                            <FormHelperText className={classes.error}>{comboProperty.label} <FormattedMessage id="textfield.error.isrequirededmessage" defaultMessage="is required" /></FormHelperText>
                        )}
                    </div>
                </FormControl>
            </Grid>)}


            { !comboProperty.isHookFormType && (<Grid item xs={12} sm={12} md={12} lg={12} style={{ marginTop: "3px" }}>
                <FormControl fullWidth>
                    <Autocomplete
                        fullWidth
                        openOnFocus={true}
                        onChange={(event, newValue) => {
                            if (typeof newValue === 'string') {

                                if (newValue != null) {
                                    setComboValue({
                                        newValue,
                                    });
                                }
                            } else if (newValue && newValue.inputValue) {
                                // Create a new value from the user input
                                setComboValue({
                                    title: newValue.inputValue,
                                });

                            }
                            else if (newValue !== null) {

                                setComboValue(newValue);
                            } else if (newValue === null) {
                                setComboValue('')
                            } else {
                                setComboValue(newValue);
                            }
                        }}
                        selectOnFocus
                        loadingText="Loading..."
                        loading={isLoading}
                        handleHomeEndKeys
                        value={comboValue.groupDescription || null}
                        autoHighlight
                        onOpen={() => {
                            loadGroupDescriptionData('');
                        }}
                        options={groupDescriptionData}
                        getOptionLabel={(option) => {

                            if (typeof option === 'string') {
                                return option;
                            }
                            if (option.inputValue) {
                                return option.inputValue;
                            }
                            return option.groupDescription;
                        }}
                        getoptionselected={(option, value) => option.groupDescription === value}
                        disabled={comboProperty.isDisabled}
                        renderInput={params => (
                            <Tooltip title={comboValue.groupDescription || ''}>
                                <TextField
                                    {...params}
                                    autoFocus={comboProperty.isAutofocus}
                                    name={comboProperty.groupDescription}
                                    onChange={(ev) => {
                                        if (
                                            ev.target.value !== "" ||
                                            ev.target.value !== null
                                        ) {
                                            loadGroupDescriptionData(ev.target.value);
                                        }
                                    }}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    InputProps={{
                                        ...params.InputProps,
                                        endAdornment: (
                                            <React.Fragment>
                                                {isLoading ?
                                                    <CircularProgress color="inherit" size={20} />
                                                    : null}
                                                {params.InputProps.endAdornment}
                                            </React.Fragment>
                                        ),
                                    }}
                                    size='small'
                                    label={comboProperty.label + (comboProperty.isRequired ? ' *' : '')}
                                    variant={comboProperty.variant}
                                />
                            </Tooltip>
                        )}

                    />
                </FormControl>
            </Grid>)}
        </React.Fragment>
    );
};           

GroupDescriptionCombo.propTypes = {
    comboProperty: PropTypes.object.isRequired,
    control: PropTypes.any,
    errors: PropTypes.any,
    comboValue: PropTypes.any.isRequired,
    setComboValue: PropTypes.func.isRequired
};

export default GroupDescriptionCombo;
